import $axios from './api';

export const create = async (payload) => {
	const { data } = await $axios.post('/v1/author/qa/create', payload);
	return data;
};

export const list = async (payload) => {
	const { data } = await $axios.post('/v1/author/qa/list', payload);
	return data;
};

export const getById = async (id) => {
	const { data } = await $axios.get(`/v1/author/qa/${id}`);
	return data;
};

export const update = async (id, payload) => {
	const { data } = await $axios.post(`/v1/author/qa/${id}`, payload);
	return data;
};

export const remove = async (id) => {
	const { data } = await $axios.delete(`/v1/author/qa/${id}`);
	return data;
};
